<div class="video-container">
  <div class="media-player">
    <div class="thumbnail" (click)="play()" @fadeOut *ngIf="!isPlaying">
      <div class="play-icon">
        <i class="material-symbols-outlined">play_arrow</i>
      </div>
      <img [src]="video?.Image | contentImage: '24'" />
    </div>
    <ng-template #playerContainer></ng-template>
  </div>
</div>
